import { type ColumnDef, Grid } from '@strata/react-grid';
import { RadioButtonGroup } from '@strata/react-radio-button-group';
import { SuggestSingleSelect } from '@strata/react-selects';
import { useEffect, useState } from 'react';

import { type MemberType, MemberTypeOptions, MemberTypes } from 'services/constants';
import { type Member, useLazyGetMemberListQuery } from 'store/api/oopsApi';
import { type Payer, useGetPayerListQuery } from 'store/api/referenceApi';

const columns: ColumnDef<Member>[] = [
    { header: 'Member Id', accessorKey: 'memberId' },
    { header: 'First Name', accessorKey: 'firstName' },
    { header: 'Last Name', accessorKey: 'lastName' },
    { header: 'Date of Birth', accessorKey: 'dateOfBirth' },
    { header: 'Benefit Group', accessorKey: 'benefitGroup' },
    { header: 'Benefit Code', accessorKey: 'benefitCode' },
    { header: 'Relationship Code', accessorKey: 'relationshipCode' },
];

export const ViewMember = () => {
    const [selectedPayer, setSelectedPayer] = useState<Payer>();
    const [selectedMemberType, setSelectedMemberType] = useState<MemberType>(MemberTypes.TEST);

    const { data: payerList, isFetching: payerListFetching } = useGetPayerListQuery();

    const [getMemberList, { data: memberList, isFetching: memberListFetching }] =
        useLazyGetMemberListQuery();

    useEffect(() => {
        void (async () => {
            if (selectedPayer && selectedMemberType) {
                await getMemberList({
                    payerId: selectedPayer.payerId,
                    memberType: selectedMemberType,
                });
            }
        })();
    }, [selectedPayer, selectedMemberType, getMemberList]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <SuggestSingleSelect
                label="Payer Id"
                id="payerId"
                name="payerId"
                required
                isLoading={payerListFetching}
                values={payerList}
                selectedItem={selectedPayer}
                onChange={(newValue) => {
                    setSelectedPayer(newValue);
                }}
            />
            <RadioButtonGroup
                name="memberType"
                label="Member Type"
                options={MemberTypeOptions}
                selectedValue={selectedMemberType}
                onChange={(newValue) => setSelectedMemberType(newValue as MemberType)}
                inline
            />
            <Grid data={memberList} isLoading={memberListFetching} columns={columns} />
        </div>
    );
};
